import React from "react";
import ReactModal from "react-modal";
import { createGlobalStyle } from "styled-components";
import {
  Color,
  Radius,
  Transition,
  ZIndexes,
  cover,
  transparentize,
} from "@glossy";

document &&
  document.getElementById("#main") &&
  ReactModal.setAppElement("#main");

const GlobalStyle = createGlobalStyle`
  .overlay {
    ${cover()};
    overflow: hidden;
    background-color: ${transparentize(0.5, Color.Black)};
    transition: opacity ${Transition.Color} linear;
    opacity: 0;
    z-index: ${ZIndexes.Modal};
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .overlay-after-open {
    opacity: 1;
  }
  .overlay-before-close {
    opacity: 0;
  }
  .modal {
    position: relative;
    overflow: hidden;
    top: -100px;
    border-radius: ${Radius.Large};
    transition: top ${Transition.Length} ease-out;
  }
  .modal-after-open {
    top: 0;
  }
  .modal-before-close {
    top: -100px;
  }
`;

interface IProps {
  // Boolean describing if the modal should be shown or not.
  isOpen: boolean;
  // Embeded elements
  children: React.ReactNode;
  // Function that will be called to get the parent element that the modal will be attached to.
  parentSelector?: () => void;
  // Action when click on close
  onCancel?: () => void;
}

const UiKitModalContainer = ({
  isOpen,
  children,
  parentSelector,
  onCancel,
}: IProps) => (
  <>
    <GlobalStyle />
    <ReactModal
      isOpen={isOpen}
      closeTimeoutMS={300}
      onRequestClose={onCancel}
      parentSelector={parentSelector}
      overlayClassName={{
        base: "overlay",
        afterOpen: "overlay-after-open",
        beforeClose: "overlay-before-close",
      }}
      className={{
        base: "modal",
        afterOpen: "modal-after-open",
        beforeClose: "modal-before-close",
      }}
      ariaHideApp={false}
    >
      {children}
    </ReactModal>
  </>
);

export default UiKitModalContainer;
